// extracted by mini-css-extract-plugin
module.exports = {"button":"_6c97079b1b--button--1kPnK","icon":"_6c97079b1b--icon--1OXUJ"};